import { render, staticRenderFns } from "./TSwitch.vue?vue&type=template&id=2627a7f0&scoped=true&"
import script from "./TSwitch.vue?vue&type=script&lang=js&"
export * from "./TSwitch.vue?vue&type=script&lang=js&"
import style0 from "./TSwitch.vue?vue&type=style&index=0&id=2627a7f0&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2627a7f0",
  null
  
)

export default component.exports